<template>
  <div class="popup-mask show" @click="$emit('close')">
    <div class="popup auth-popup" @click.stop>
      <div class="auth-header">
        <h3>{{ currentMode === 'login' ? '欢迎回来' : '创建账号' }}</h3>
        <div class="auth-close" @click="$emit('close')">关闭</div>
      </div>

      <p>
        请输入账号和密码，首版仅做前端演示，不连接真实接口。
      </p>

      <form @submit.prevent="submitForm">
        <div class="field">
          <label for="authUsername">账号</label>
          <input id="authUsername" v-model.trim="form.username" type="text" placeholder="请输入账号">
        </div>

        <div class="field">
          <label for="authPassword">密码</label>
          <input id="authPassword" v-model.trim="form.password" type="password" placeholder="请输入密码">
        </div>

        <div v-if="currentMode === 'register'" class="field">
          <label for="authConfirmPassword">确认密码</label>
          <input
            id="authConfirmPassword"
            v-model.trim="form.confirmPassword"
            type="password"
            placeholder="请再次输入密码"
          >
        </div>

        <div class="form-actions">
          <button class="btn" type="submit">
            {{ submitting ? '提交中...' : currentMode === 'login' ? '立即登录' : '立即注册' }}
          </button>

          <button class="ghost-btn" type="button" @click="toggleMode">
            {{ currentMode === 'login' ? '去注册' : '已有账号，去登录' }}
          </button>

          <button class="ghost-btn" type="button" @click="copyLink">
            复制本站链接
          </button>
        </div>
      </form>

      <div class="helper-text" :class="feedbackClass">{{ feedbackText }}</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { copyCurrentLink } from "@/prototype/render-helpers";
import { loginApi } from "@/api/api";

export default {
  name: "AuthModal",
  props: {
    mode: {
      type: String,
      default: "login",
    },
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        confirmPassword: "",
      },
      submitting: false,
      feedbackText: "请输入账号和密码后提交。",
      feedbackType: "",
    };
  },
  computed: {
    currentMode() {
      return this.mode === "register" ? "register" : "login";
    },
    feedbackClass() {
      if (this.feedbackType === "success") return "success-text";
      if (this.feedbackType === "error") return "error-text";
      return "";
    },
  },
  watch: {
    mode() {
      this.resetForm();
    },
  },
  methods: {
    notify(message) {
      if (this.$toast) {
        this.$toast(message);
        return;
      }
      if (Vue.prototype.$toast) {
        Vue.prototype.$toast(message);
      }
    },
    resetForm() {
      this.form.username = "";
      this.form.password = "";
      this.form.confirmPassword = "";
      this.submitting = false;
      this.feedbackType = "";
      this.feedbackText =
        this.currentMode === "login"
          ? "请输入账号和密码后登录。"
          : "注册成功后会自动完成登录。";
    },
    toggleMode() {
      this.$emit("change-mode", this.currentMode === "login" ? "register" : "login");
    },
    async copyLink() {
      try {
        await copyCurrentLink();
        this.feedbackType = "success";
        this.feedbackText = "链接已复制，请尽快保存到浏览器收藏夹或备忘录。";
        this.notify("链接已复制，请尽快保存到浏览器收藏夹或备忘录。");
      } catch (error) {
        this.feedbackType = "error";
        this.feedbackText = "当前环境未能自动复制，请手动复制地址栏链接。";
        this.notify("当前环境未能自动复制，请手动复制地址栏链接。");
      }
    },
    async submitForm() {
      if (!this.form.username) {
        this.feedbackType = "error";
        this.feedbackText = "请输入账号。";
        this.notify("请输入账号");
        return;
      }

      if (!this.form.password) {
        this.feedbackType = "error";
        this.feedbackText = "请输入密码。";
        this.notify("请输入密码。");
        return;
      }

      if (this.currentMode === "register" && this.form.password !== this.form.confirmPassword) {
        this.feedbackType = "error";
        this.feedbackText = "两次输入的密码不一致。";
        this.notify("两次输入的密码不一致");
        return;
      }

      this.submitting = true;
      this.feedbackType = "";
      this.feedbackText = this.currentMode === "login" ? "登录中..." : "注册中...";

      try {
        const res = await loginApi({
          username: this.form.username,
          password: this.form.password,
          loginType: this.currentMode === "register" ? 1 : 2,
        });

        if (res && res.code == 1 && res.data) {
          window.localStorage.setItem("token", res.data.token || "");
          window.localStorage.setItem("userid", res.data.id || "");
          window.localStorage.setItem("userInfo", JSON.stringify(res.data));
          window.dispatchEvent(new Event("auth-changed"));

          this.feedbackType = "success";
          this.feedbackText = res.msg || (this.currentMode === "login" ? "登录成功" : "注册成功");
          this.$emit("success", res.data);
          this.notify(this.feedbackText);

          setTimeout(() => {
            this.$emit("close");
          }, 500);
          return;
        }
       
        this.feedbackType = "error";
        this.feedbackText = (res && res.msg) || "操作失败，请稍后重试。";
        this.notify(this.feedbackText);
      } catch (error) {
        this.feedbackType = "error";
        this.feedbackText = "请求失败，请稍后重试。";
        this.notify(this.feedbackText);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-popup {
  text-align: left;
}

.auth-close {
  color: var(--muted);
  font-size: 13px;
  padding: 4px 10px;
  background: #f2f3f5;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
}

.auth-close:active {
  background: #e8e8e8;
  transform: scale(0.95);
}
</style>
